import * as actionTypes from "../constants/actionTypes";
import * as config from "../config";

export function storeRegistrationMembershipType(registrationMembershipType) {
	localStorage.setItem(config.storageKeys.registrationMembershipType, registrationMembershipType);
	return {
		type: actionTypes.REGISTRATION_MEMBERSHIP_TYPE_STORE,
		registrationMembershipType,
	};
}

export function storeJoinRenewMembershipType(joinRenewMembershipType) {
	localStorage.setItem(config.storageKeys.joinRenewMembershipType, joinRenewMembershipType);
	return {
		type: actionTypes.MEMBERSHIP_JOIN_RENEW_TYPE_STORE,
		joinRenewMembershipType,
	};
}
